import Vue from 'vue';
export default {
    bus : new Vue()
};